import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=2ab4e796"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"
import style0 from "./Bonus.vue?vue&type=style&index=0&id=2ab4e796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports